// extracted by mini-css-extract-plugin
export default {"userContainer":"Avatar_userContainer__SXFqm","userText":"Avatar_userText__6uHDM"};